<template>
    <tr>
        <td class="text-nowrap">{{user.name}}</td>
        <td class="text-nowrap">{{role_names}}</td>
        <td class="small">{{sources}}</td>
        <td style="width: 130px" class="text-right"><button class="btn btn-primary btn-sm" @click="onOpenEditForm" type="button" form="">Редактировать</button></td>
    </tr>
</template>

<script>
import UserRegisterParams from "../users/UserRegisterParams.vue";
import AgencyUserForm from "./AgencyUserForm.vue";

export default {
    name: "AgencyUserListItem",
    props: ['user'],
    data: () => ({

    }),
    computed: {
        sources() {
            return this.user.sources.map(function (s) {
                return s.name;
            }).join(", ");
        },
        role_names() {
            let labels = [];
            this.user.roles.forEach(r => {
                switch (r.name) {
                    case "head_of_agency": labels.push("Руководитель"); break;
                    case "agent": labels.push("Агент"); break;
                }
            })
            return labels.join(", ");
        },
    },
    methods: {
        onOpenEditForm() {
            this.$emit('openEditForm', this.user)
        }
    }
}
</script>

<style scoped>

</style>
